import CoordinatesPanelItem from './CoordinatesPanelItem'

export default CoordinatesPanelItem
